(function () {
  angular.module('MktzapApp.Factories')
    .factory('MassUserService', MassUserService);

  MassUserService.$inject = ['$resource'];

  function MassUserService ($resource) {
    return $resource(apiUrl + '/mass-user', { }, {
      createUsers: { url: apiUrl + '/mass-user/create-users', method: 'POST', params: {}, isArray: false },
      inactivateUsers: { url: apiUrl + '/mass-user/inactivate-users', method: 'POST', params: {}, isArray: false },
    });
  }
})();